export default __webpack_public_path__ + "static/media/Soul.473053c9.mp3";